"use client";

import {
  BorderStyle,
  IconProvider,
  LayoutProvider,
  NeutralColor,
  ScalingSize,
  Schemes,
  SolidStyle,
  SolidType,
  SurfaceStyle,
  ThemeProvider,
  TransitionStyle,
} from "@/lib/once-ui";
import { style } from "../resources";
import { iconLibrary } from "../resources/icons";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <LayoutProvider>
      <ThemeProvider
        brand={style.brand as Schemes}
        accent={style.accent as Schemes}
        neutral={style.neutral as NeutralColor}
        solid={style.solid as SolidType}
        solidStyle={style.solidStyle as SolidStyle}
        border={style.border as BorderStyle}
        surface={style.surface as SurfaceStyle}
        transition={style.transition as TransitionStyle}
        scaling={style.scaling as ScalingSize}
      >
        {/* No DataThemeProvider (recharts) and no ToastProvider (its
            Toaster import drags the whole component barrel): the site
            renders neither charts nor toasts. */}
        <IconProvider icons={iconLibrary}>{children}</IconProvider>
      </ThemeProvider>
    </LayoutProvider>
  );
}
